module.exports = __webpack_public_path__ + "static/texture-chalk-0c73be67242992dbfcbf56c68e19499a.png";